import React from 'react';
import { GiftIcon, SparklesIcon } from 'lucide-react';
const bonuses = [{
  title: 'Taller Completo de Wax Melts',
  value: '$8,000',
  description: 'Ampliá tu catálogo con otro producto súper rentable'
}, {
  title: 'Wax Melts Cuchareables',
  value: '$5,000',
  description: 'Una variante innovadora que se vende sola'
}, {
  title: 'Manual Profesional de Velas',
  value: '$4,000',
  description: 'Por si querés complementar tu oferta (PDF descargable)'
}, {
  title: 'Taller "Hacé tus propios moldes"',
  value: '$3,000',
  description: 'Ahorrá dinero haciendo tus propios moldes personalizados'
}, {
  title: 'Errores Comunes y Cómo Evitarlos',
  value: '$2,000',
  description: 'Te ahorro meses de prueba y error con esta guía'
}, {
  title: 'Soporte 24/7',
  value: '$1,000',
  description: 'No estás sola: tenés ayuda cuando la necesites'
}];
export function BonusSection() {
  return <section className="bg-amber-50 py-12 md:py-16 px-4 relative overflow-hidden" data-id="element-26">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10" data-id="element-27">
        <div className="absolute top-0 left-0 w-64 h-64 bg-pink-300 rounded-full blur-3xl" data-id="element-28"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-rose-300 rounded-full blur-3xl" data-id="element-29"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-30">
        <div className="text-center mb-8 md:mb-12" data-id="element-31">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-400 to-rose-400 text-white px-6 py-3 rounded-full mb-4 animate-pulse-urgent shadow-lg" data-id="element-32">
            <SparklesIcon className="w-6 h-6" aria-hidden="true" data-id="element-33" />
            <span className="font-extrabold text-lg uppercase" data-id="element-34">
              BONOS EXCLUSIVOS
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-pink-600 leading-tight mb-4" data-id="element-35">
            ¡GRATIS Cuando Actúes HOY!
          </h2>
          <p className="text-xl md:text-2xl text-rose-500 font-bold" data-id="element-36">
            Valor Total: $25,000 - TUYO GRATIS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-37">
          {bonuses.map((bonus, index) => <article key={index} className="bg-white border-4 border-pink-300 rounded-xl p-6 shadow-2xl relative" data-id="element-38">
              {/* GRATIS stamp */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-pink-500 to-rose-500 text-white px-4 py-2 rounded-lg rotate-12 shadow-xl border-2 border-pink-600" data-id="element-39">
                <span className="font-extrabold text-sm uppercase" data-id="element-40">
                  GRATIS HOY
                </span>
              </div>

              {/* Bonus Image (if available) */}
              {bonus.image && <div className="mb-4 -mx-6 -mt-6" data-id="element-41">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-48 object-cover rounded-t-lg" data-id="element-42" />
                </div>}

              <div className="flex items-center gap-3 mb-4" data-id="element-43">
                <div className="bg-gradient-to-r from-pink-400 to-rose-400 rounded-full p-3" data-id="element-44">
                  <GiftIcon className="w-6 h-6 text-white" aria-hidden="true" data-id="element-45" />
                </div>
                <div data-id="element-46">
                  <p className="text-sm text-rose-500 font-bold" data-id="element-47">
                    BONUS #{index + 1}
                  </p>
                  <p className="text-lg text-stone-500 line-through" data-id="element-48">
                    {bonus.value}
                  </p>
                </div>
              </div>

              <h3 className="text-xl md:text-2xl font-extrabold text-pink-600 mb-3 leading-tight" data-id="element-49">
                {bonus.title}
              </h3>
              <p className="text-base md:text-lg text-stone-700 font-semibold" data-id="element-50">
                {bonus.description}
              </p>
            </article>)}
        </div>

        {/* Total Value Summary */}
        <div className="mt-12 bg-gradient-to-r from-pink-400 to-rose-400 rounded-2xl p-8 text-center border-4 border-pink-500 shadow-2xl" data-id="element-51">
          <p className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-52">
            VALOR TOTAL DE LOS BONOS:
          </p>
          <p className="text-5xl md:text-6xl font-extrabold text-white line-through mb-4" data-id="element-53">
            $25,000
          </p>
          <p className="text-3xl md:text-4xl font-extrabold text-pink-600 bg-white inline-block px-8 py-3 rounded-lg shadow-lg" data-id="element-54">
            GRATIS HOY
          </p>
        </div>
      </div>
    </section>;
}